function loadCarsList(){

  $(".js-mob-back-second").on("click", function(){
    $(".subcontent__services-cont").css({
      "transform": "translateX(0)"
    })
    $(".js-cars-cont").css({
      "transform": "translateX(100%)"
    })
  })

   $( document ).ready(function() {
    $(document).on("click", ".js-services-list-item", function (event) {
      event.stopPropagation();
      var vw = $(window).width();
      var url = $(this).data("url") ? $(this).data("url") : $(this).find('.subcontent__container').data("url");
      switch (vw < 768) {
        /*mobile handle*/
        case true:
          var slideStep = $(this).data("url") ? -87 : 0;
          $(this).parents(".subcontent__services-cont").css({
            "transform": "translateX(-120%)"
          });
          $(".js-cars-cont").css({
            "transform": "translateX(" + slideStep + "%)"
          });
          loadIt(url, $(this));
          break;
        /*desktop handle*/
        case false:
          loadIt(url, $(this));
          break;
      }

      //setTimeout - имитируем время получение ответа от сервера.
    });
  });

  function cleanCont(){
    $(".js-cars-cont").find(".cars").remove();
    $(".scrollable__bottomShadow").remove();
    $(".scrollable__topShadow").remove();
    if (!sfm(sf_style)) {
      $(".js-loader").fadeIn();
    } else {
      $(".js-loader").fadeIn('fast');
    }
  }

  function getActive(el) {
    $(".services__item.active").removeClass("active");
    if (el.parent().hasClass('services__item')) {
      el.parent().addClass("active");
    }
  }

  function loadIt(url,el) {
    if (!$(".js-cars-cont").hasClass("is-loading")) {
      $(".js-cars-cont").addClass("is-loading");
      getAndAppend(url);
      getActive(el);
      cleanCont();
    }
  }

  function getAndAppend(url) {
    if (sfm(sf_style)) {
      var stt = 0;
    } else {
      var stt = 1000;
    }
    $.ajax({
      url: url,
      type: "GET",
      beforeSend: function(){
        if (sfm(sf_style)) {
          $(".js-loader").fadeIn('fast');
        }
      },
      success: function success(answer) {
        setTimeout(function () {
          if (!sfm(sf_style)) {
            $(".js-loader").fadeOut();
          } else {
            $(".js-loader").fadeOut('fast');
          }
          $(".js-cars-cont").append(answer);
          scrollable($(".js-cars-cont"));
          $(".js-cars-cont").removeClass("is-loading");
        }, stt);
      },
      error: function error(e) {
        console.log(e);
      }
    });
  }
}
